

const urlParams = new URLSearchParams(window.location.search);
export function getUrlParam(key){
    return urlParams.get(getKey(key))
}

export function getKey(searchString){
    for (var key of urlParams.keys()) {
      if (searchString.toLowerCase() === key.toLowerCase()) {
        return key;
      }
    }
    return searchString;
  };